import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconParkTwotoneLightning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 26,
	viewBox: "0 0 25 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_5956_18611",
		style: { maskType: "luminance" },
		maskUnits: "userSpaceOnUse",
		x: 3,
		y: 1,
		width: 20,
		height: 24,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.89323 2.58398H19.2682L13.5391 9.87565H21.3516L8.85156 23.4173L11.4557 13.5215H4.16406L9.89323 2.58398Z",
			fill: "#515610",
			stroke: "#B9F833",
			strokeWidth: 2.08333,
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_5956_18611)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 0.5H25V25.5H0V0.5Z",
			fill: "#00F7FF"
		})
	})]
});
export default SvgIconParkTwotoneLightning;
